(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ppy-gift-proposal"] && !Shopify.designMode) return;
  try {
    
function initGiftProposal(root) {
  if (root.dataset.initialised) return;
  root.dataset.initialised = 'true';
  const update = () => {
    const physical = root.querySelector('input[name^="gift-format-"]:checked').value === 'physical';
    const physicalImage = root.querySelector('.pg-physical-image');
    if (physicalImage) physicalImage.hidden = !physical;
    root.querySelector('.pg-digital-image').hidden = physical;
    root.querySelectorAll('[data-format-note]').forEach(note => { note.hidden = note.dataset.formatNote !== (physical ? 'physical' : 'digital'); });
    const cents = Number(root.querySelector('input[name^="gift-amount-"]:checked').dataset.cents) + (physical ? 1200 : 0);
    root.querySelector('[data-price]').textContent = new Intl.NumberFormat(root.dataset.locale || 'en-AU', {style:'currency',currency:root.dataset.currency || 'AUD'}).format(cents / 100);
    root.querySelector('.pg-personalise').hidden = !physical;
    if (physical) root.querySelector('.pg-personalise').open = true;
    root.querySelectorAll('.pg-confirmation').forEach(note => { note.hidden = true; });
  };
  root.addEventListener('change', update);
  update();
  let busy = false;
  const addGift = async (box) => {
    if (busy) return;
    const button = root.querySelector(box ? '[data-box-preview]' : '[data-preview-button]');
    const status = root.querySelector(box ? '[data-box-confirmation]' : '.pg-config .pg-confirmation');
    const physical = !box && root.querySelector('input[name^="gift-format-"]:checked').value === 'physical';
    const selection = box ? root.querySelector('input[name^="gift-box-"]:checked').value : null;
    const cents = box ? {adult:7900,child:5900,two:15800}[selection] : null;
    const variant = box ? root.querySelector('input[name^="gift-amount-"][data-cents="' + cents + '"]') : root.querySelector('input[name^="gift-amount-"]:checked');
    if (!variant) { status.textContent = root.dataset.error; status.hidden = false; return; }
    const properties = {'Gift format': box ? 'Positiva gift box' : physical ? 'Physical card + envelope' : 'Digital gift card'};
    if (root.dataset.portugal === 'true') {
      properties['Formato'] = 'Cartão-presente digital';
      properties['Experiência'] = variant.closest('label').querySelector('small').textContent.trim();
      delete properties['Gift format'];
    }
    if (physical) {
      const to = root.querySelector('[data-gift-to]').value.trim();
      const from = root.querySelector('[data-gift-from]').value.trim();
      if (to) properties.To = to;
      if (from) properties.From = from;
    }
    const group = window.crypto.randomUUID();
    properties._gift_group = group;
    const items = [{id:Number(variant.value),quantity:1,properties}];
    if (box || physical) items.push({id:Number(box ? root.dataset.boxAddon : root.dataset.cardAddon),quantity:1,properties:{...properties,'Gift card value':new Intl.NumberFormat(root.dataset.locale || 'en-AU',{style:'currency',currency:root.dataset.currency || 'AUD'}).format(Number(variant.dataset.cents)/100)}});
    busy = true;
    root.querySelectorAll('.pg-cta').forEach(el => { el.disabled = true; });
    button.setAttribute('aria-busy','true');
    status.hidden = true;
    try {
      const response = await fetch(root.dataset.cartAdd,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : root.dataset.error);
      window.location.assign(root.dataset.cartUrl);
    } catch (error) {
      status.textContent = error.message || root.dataset.error;
      status.hidden = false;
      busy = false;
      root.querySelectorAll('.pg-cta').forEach(el => { el.disabled = false; });
      button.removeAttribute('aria-busy');
    }
  };
  root.querySelector('[data-box-preview]')?.addEventListener('click', () => addGift(true));
  root.querySelector('[data-preview-button]').addEventListener('click', () => addGift(false));
}
document.querySelectorAll('[data-gift-proposal]').forEach(initGiftProposal);
document.addEventListener('shopify:section:load', event => { event.target.querySelectorAll('[data-gift-proposal]').forEach(initGiftProposal); });

  } catch(e) { console.error(e); }
})();
})();
